import React from "react";
import { lazySetContainerInSection, lazySetContainerInSectionChildWindow } from "../";
import type { AppSectionName } from "../interface/AppSection";

export function useRegisterNavigationLoopContainer(sectionName: AppSectionName, containerRef: React.RefObject<HTMLElement | null | undefined>, shouldSkipAdding: boolean = false, depsArray: React.DependencyList = []): void {
    const promiseRef = React.useRef<Promise<() => void> | undefined>(undefined);
    React.useEffect(() => {
        if (shouldSkipAdding || !containerRef.current) {
            return;
        }
        
        const container = containerRef.current;
        const isChildWindow = container.ownerDocument?.defaultView !== window;
        
        promiseRef.current = isChildWindow
            ? lazySetContainerInSectionChildWindow.importAndExecute(sectionName, container)
            : lazySetContainerInSection.importAndExecute(sectionName, container);
        
        return () => {
            promiseRef.current?.then(disposeCb => {
                disposeCb?.();
                promiseRef.current = undefined;
            });
        };
    }, depsArray);
}
